"use strict";

module.exports = function (value, column) {
  var list = this.listColumnsObject[column];
  if (typeof list[value] == 'undefined') return value;
  return list[value];
};


//////////////////
// WEBPACK FOOTER
// ./~/vue-tables-2/compiled/filters/option-text.js
// module id = 1595
// module chunks = 61